<template><div><h1 id="mahnungen-manuell-bestatigen" tabindex="-1"><a class="header-anchor" href="#mahnungen-manuell-bestatigen"><span>Mahnungen manuell bestätigen</span></a></h1>
<p>Mahnungen manuell bestätigen — Offene Zahlungen manuell zur Mahnung freigeben</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Falls sich in vorhergehendem Schritt Offene Posten ergeben, die manuell zu bestätigen sind, müssen diese in diesem Schritt bearbeitet werden (mahnen/nicht mahnen).</p>
<p>Pfad: <code v-pre>Buchhaltung → Verarbeitungsläufe → Mahnwesen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Personen-ID</dt>
<dd>Personen-ID des Mahnungsempfängers</dd>
<dt>Name</dt>
<dd>Vorname, Name resp. Firma</dd>
<dt>Faktura</dt>
<dd>Fakturanummer</dd>
<dt>Fakturadatum</dt>
<dd>Datum der Fakturierung</dd>
<dt>Fälligkeitsdatum</dt>
<dd>Fälligkeit der Faktura</dd>
</dl>
<p>Mahnstufe
:</p>
<dl>
<dt>Schärfe / Schärfecode</dt>
<dd>Schärfecode der potentiellen Mahnung</dd>
<dt>Umsatz</dt>
<dd>Umsätze der Adresse</dd>
<dt>Saldo</dt>
<dd>Saldo der Adresse</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<dl>
<dt>mahnen</dt>
<dd>Mahnung aufbereiten, Verfalldatum erhöhen: Die Faktura wird im Mahnlauf belassen</dd>
<dt>nicht mahnen</dt>
<dd>Mahnung nicht aufbereiten, das Fälligkeitsdatum kann angepasst werden.</dd>
<dt>ändern</dt>
<dd>Erhöhung des Fälligkeitsdatums und/oder Angabe eines speziellen Mahntextes. Diese Einstellung hat keinen direkten Einfluss darauf, ob die Faktura gemahnt wird oder nicht (Zuordnung noch erforderlich).</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.mahnprot.html" title="Mahnungen Protokoll">Mahnungen, Protokoll</RouteLink></p>
</div></template>


